import React from "react";

const Display = ({displayValue}) => {
  return <div className="display"><span>{displayValue}</span></div>;
};

export default Display;
